import PartnerPaymentViewIcon from '@material-ui/icons/ViewList';

import PartnerPaymentViewList from './PartnerPaymentViewList';

export default {
  list: PartnerPaymentViewList,
  icon: PartnerPaymentViewIcon,
};
